import React, { useEffect } from 'react';

function Home() {
  const dashboardPath = process.env.REACT_APP_BETA_OBOK_URL;

  useEffect(() => {
    window.location.replace(dashboardPath);
  }, []);

  return null;
}

export default Home;
